import React, { useEffect, useState } from "react";
import { Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Form, FormGroup, FormInput, FormSelect, FormTextarea, Button, Alert, FormCheckbox } from "shards-react";
import { Store } from "../flux";

const AreaDetails = props => {

    const [ Details, SetDetails ] = useState({});
    const [ ShowAlert, SetShowAlert ] = useState(false);

    useEffect(() => {

        SetDetails(props.Area);

        console.log(props.Area);
    }, [ props.Area ]);

    const updateArea = async () => {

        const UpdateData = JSON.stringify({ id: Details.id, name: Details.name, ni_council: Details.ni_council });
        await fetch("https://app-centre.tascomi.com/app-centre.php?end_point=update_area_details&data=" + UpdateData);
        await Store.retrieveApps();
        await Store.retrieveAreas();

        await SetShowAlert(true);

        setTimeout(() => {

            SetShowAlert(false);
        }, 2000);
    }

	return (
		<Card small className="mb-4">
			<CardHeader className="border-bottom">
				<h6 className="m-0">Area Details</h6>
			</CardHeader>

			<ListGroup flush>
				<ListGroupItem className="p-3">
					<Row>
						<Col>
							<Form>
								<Row form>

									{/* App Name */}
									<Col md="6" className="form-group">
										<label htmlFor="name">Name</label>
										<FormInput id="name" placeholder="Area Name" value={ Details.name } onChange={ (e) => { props.Change(e.target.value, e.target.id)} } />
									</Col>

                                    {/* App is NI Council */}
                                    <Col md="6" className="form-group">
										<label htmlFor="ni_council">NI Council?</label>
										<FormCheckbox toggle id="ni_council" placeholder="Area NI Council" onChange={ (e) => { props.Change(Details.ni_council === "t" ? "f" : "t", e.target.id)} } checked={ Details.ni_council === "t" } />
									</Col>
								</Row>

								<Button theme="accent" onClick={ updateArea }>Update Area</Button>

                                { ShowAlert &&
                                    <>
                                        <br /><br />
                                        <Alert className="alert-success alert-dismissible fade show mb-0" role="alert">
                                            <i className="fa fa-check mx-2"></i>
                                            <strong>Success!</strong> { props.Area.name } has been updated.
                                        </Alert>
                                    </>
                                }
							</Form>
						</Col>
					</Row>
				</ListGroupItem>
			</ListGroup>
		</Card>
	);
}

export default AreaDetails;
